var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-player",on:{"click":function($event){$event.stopPropagation();}}},[_c(_setup.VuePlyr,{ref:"videoPlayer",attrs:{"options":_setup.options}},[_c('video',{attrs:{"poster":_setup.coverImage,"controls":"","crossorigin":"anonymous","playsinline":""}},[_c('source',{ref:"videoSourceEl"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }